import React from 'react';
export function GoldDivider() {
  return <div className="flex items-center justify-center py-2" data-id="element-111">
      <div className="h-px w-24 bg-gradient-to-r from-transparent to-brand-gold/50" data-id="element-112" />
      <div className="mx-3 w-1.5 h-1.5 rotate-45 bg-brand-gold" data-id="element-113" />
      <div className="h-px w-24 bg-gradient-to-l from-transparent to-brand-gold/50" data-id="element-114" />
    </div>;
}